import { render, staticRenderFns } from "./VoortgangWoorden.vue?vue&type=template&id=4cf60a06&scoped=true"
import script from "./VoortgangWoorden.vue?vue&type=script&lang=js"
export * from "./VoortgangWoorden.vue?vue&type=script&lang=js"
import style0 from "./VoortgangWoorden.vue?vue&type=style&index=0&id=4cf60a06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf60a06",
  null
  
)

export default component.exports